module.exports = __webpack_public_path__ + "static/images/containers/ChallengeView/images/background-superiority-cn.bfe72101.jpg";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengeView/images/background-superiority-cn.jpg
// module id = 2821
// module chunks = 11